exports = module.exports = require("../../../../node_modules/_css-loader@0.26.4@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.tofu-button-component {\n  box-sizing: border-box;\n  height: 24px;\n  line-height: 22px;\n  color: #fff;\n  border: 1px solid transparent;\n  border-radius: 2px;\n  background: transparent;\n  cursor: pointer;\n  user-select: none;\n}\n.tofu-button-component:hover {\n    border: 1px solid #364357;\n    background: #313D4F;\n}\n.tofu-button-component.button-active {\n    border: 1px solid #14161A;\n    background: #14161A;\n}\n.tofu-button-component .button-label {\n    box-sizing: border-box;\n    height: 100%;\n    padding: 5px 0;\n    font-size: 12px;\n    text-align: left;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.26.4@css-loader!./~/_vue-loader@10.3.0@vue-loader/lib/style-rewriter.js?id=data-v-34aa1918!./~/_sass-loader@6.0.6@sass-loader/lib/loader.js!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=styles&index=0!./src/components/tofu-button/src/button.vue
// module id = 458
// module chunks = 0